import type {Content} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import type {FC} from 'react'
import {useWindowSize} from 'react-use'
import {AffiliateSection} from './components/AffiliateSection'
import {AffiliatesBannerGrid} from './components/AffiliatesBannerGrid'
import {ANIMATION_SPEED, CAROUSEL_THRESHOLD, GRID_CLASSES} from './constants'

/**
 * Props for `AffiliatesBanner`.
 */
export type AffiliatesBannerProps = SliceComponentProps<Content.AffiliatesBannerSlice>

/**
 * Component for "AffiliatesBanner" Slices.
 */
const AffiliatesBanner: FC<AffiliatesBannerProps> = ({slice}) => {
  const blocks = slice.primary.affiliate_block
  const length = Math.min(blocks?.length ?? 3, 5)
  const gridClass = GRID_CLASSES[length] || GRID_CLASSES[3]
  const animationClass = ANIMATION_SPEED[length] || ANIMATION_SPEED[3]
  const shouldRenderCarousel = useWindowSize().width < CAROUSEL_THRESHOLD[length]

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="relative flex h-[174px] w-full overflow-hidden bg-moss-grey-100 md:mb-8 md:h-[192px]"
    >
      <div className="absolute inset-0 flex gap-0">
        <AffiliatesBannerGrid animationClass={animationClass} gridClass={gridClass} length={length}>
          <AffiliateSection blocks={blocks} />
        </AffiliatesBannerGrid>
        {shouldRenderCarousel && (
          <AffiliatesBannerGrid animationClass={animationClass} gridClass={gridClass} length={length}>
            <AffiliateSection blocks={blocks} />
          </AffiliatesBannerGrid>
        )}
      </div>
    </section>
  )
}

export default AffiliatesBanner
